export default __webpack_public_path__ + "static/media/logout.4902439a.svg";